import type { TourSection } from './types';

export const pendingSections: TourSection[] = [
  {
    id: 'counters',
    label: 'Contadores',
    steps: [
      {
        target: '[data-tour="pending-counters"]',
        title: 'Resumen por tipo de pendiente',
        content:
          'Cuántos productos están a los que les falta cada cosa: sin categoría, sin marca, sin imagen. "Con pendientes" agrupa todos los que tienen al menos un dato incompleto. Click en cada tarjeta filtra la tabla abajo.',
      },
    ],
  },
  {
    id: 'tabs',
    label: 'Filtros por tipo',
    steps: [
      {
        target: '[data-tour="pending-tabs"]',
        title: 'Pestañas de filtro',
        content:
          '"Todos" muestra cualquier producto con datos faltantes. Las otras pestañas filtran por tipo específico (sin marca, sin categoría, sin imagen).',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado de incompletos',
    steps: [
      {
        target: '[data-tour="pending-table"]',
        title: 'Productos a completar',
        content:
          'Click en un SKU para abrir y completar lo que falta. Los pendientes se actualizan automáticamente al guardar — si completaste todo, el producto sale del listado.',
      },
    ],
  },
];
